import { useEffect, useRef } from "react";

// Embeds the POWR Form Builder. Loads powr.js once and lets it hydrate the target div.
export const PowrForm = () => {
  const mounted = useRef(false);

  useEffect(() => {
    if (mounted.current) return;
    mounted.current = true;

    const SCRIPT_SRC = "https://www.powr.io/powr.js?platform=html";
    const existing = document.querySelector(`script[src="${SCRIPT_SRC}"]`);

    if (existing) {
      // Re-trigger POWR rendering if the library is already present.
      if (window.powr && typeof window.powr.render === "function") {
        window.powr.render();
      }
      return;
    }

    const script = document.createElement("script");
    script.src = SCRIPT_SRC;
    script.async = true;
    document.body.appendChild(script);
  }, []);

  return (
    <div
      data-testid="powr-form-embed"
      className="powr-form-builder"
      id="08fa87c4_1772393840"
    />
  );
};
